<template>
  <div class="lease-item-step-base-bd">
    <el-form :model="form" ref="form" :rules="rules" label-position="top" :disabled="type == 'watch'">
      <el-row :gutter="26">
        <el-col :span="6">
          <el-form-item :label="$t('crm_lease_item_step_base.fang_an_ming_cheng')" prop="goodsName">
            <el-input v-model="form.goodsName" :placeholder="$t('Common.com_please_input')" style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('crm_lease_item_step_base.fang_an_bian_hao')" prop="goodsCode">
            <el-input v-model="form.goodsCode" :placeholder="$t('Common.com_please_input')" style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('crm_lease_item_step_base.fang_an_lei_xing')" prop="categoryId">
            <custom-select
              type="tree"
              :show-all-levels="false"
              v-model="form.categoryId"
              url="CategoryTree"
              :props="{ label: 'categoryName', value: 'categoryId', emitPath: false, checkStrictly: true }"
              :params="{ orgId: orgId }"
              :placeholder="$t('Common.com_please_select')"
              width="100%"
            ></custom-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('crm_lease_item_step_base.shang_pin_dan_wei')" prop="unit">
            <custom-select v-model="form.unit" code="after_sale_unit" :placeholder="$t('Common.com_please_select')" style="width: 100%"></custom-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="26">
        <el-col :span="6">
          <el-form-item :label="$t('crm_lease_item_step_base.zu_zhi_lei_xing')" prop="goodsSkuOwnerArr">
            <custom-select v-model="form.goodsSkuOwnerArr" multiple code="crm_scheme_owner" :placeholder="$t('Common.com_please_select')" style="width: 100%" @change="onChangeGoodsSku"></custom-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('crm_lease_item_step_base.chan_pin_xing_hao')" prop="productCodeArr">
            <custom-select
              ref="product"
              multiple
              v-model="form.productCodeArr"
              url="productCodeSelectList"
              :props="{ label: 'productName', value: 'productCode' }"
              :placeholder="$t('Common.com_please_select')"
              style="width: 100%"
              @change="onChangeProduct"
            ></custom-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('crm_lease_item_step_base.chan_pinSN')" prop="productSnArr">
            <custom-select
              ref="productSn"
              :auto="false"
              :listener="JSON.stringify(form.productCodeArr)"
              multiple
              v-model="form.productSnArr"
              url="productSnList"
              :params="{ productCodes: form.productCodeArr }"
              :props="{ label: 'codeSn', value: 'codeSn' }"
              :placeholder="$t('Common.com_please_select')"
              style="width: 100%"
            ></custom-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('crm_lease_item_step_base.zeng_song_pei_jian')">
            <el-radio-group v-model="form.isPartGiveaway">
              <el-radio :label="1">{{ $t('Common.com_yes') }}</el-radio>
              <el-radio :label="0">{{ $t('Common.com_no') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="26">
        <el-col :span="24">
          <el-form-item :label="$t('crm_lease_item_step_base.shi_yong_gong_si')">
            <custom-select
              :disabled="!form.goodsSkuOwnerArr.includes('JV')"
              v-model="form.organListArr"
              auto
              multiple
              remote
              url="OrganJvList"
              width="100%"
              filterable
              @change="onChangeOrganList"
              :props="{ label: 'orgName', value: 'orgId' }"
            ></custom-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="26">
        <el-col :span="24">
          <el-form-item :label="$t('crm_lease_item_step_base.fang_an_miao_shu')">
            <el-input type="textarea" rows="3" v-model="form.goodsDesc" placeholder style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="footer" v-if="type !== 'watch'">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="onStep()">{{ $t('Common.com_save') }}</el-button>
      <el-button type="primary" @click="onStep(true)">{{ $t('crm_lease_item_step_base.xia_yi_bu') }},{{ $t('crm_lease_item_step_base.can_shu_she_zhi') }}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    dialog: [Boolean],
    goodsId: [String, Number],
    categoryId: [String, Number],
    customerId: [String, Number],
    orgId: [String, Number],
  },
  watch: {
    goodsId: function () {
      this.getGoodsInfo();
    },
  },
  data() {
    return {
      type: '',
      form: {
        goodsId: '',
        organList: [],
        organListArr: [],
        productCodeArr: '',
        productSnArr: [],
        productList: [],
        erpCode: '',
        erpName: '',
        unit: '6',
        isPartGiveaway: 0,
        goodsSkuOwnerArr: '',
        goodsSkuOwner: '',
        categoryId: '',
        goodsCode: '',
        goodsDesc: '',
        goodsName: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        goodsSkuOwnerArr: [{ required: true, message: this.$t('crm_lease_item_step_base.qxzzzlx') }],
        goodsName: [
          { required: true, message: this.$t('crm_lease_item_step_base.qtxfamc') },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ],
        goodsCode: [
          { required: true, message: this.$t('crm_lease_item_step_base.qtxfabm') },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ],
        unit: [{ required: true, message: this.$t('crm_lease_item_step_base.qxzspdw') }],
        categoryId: [{ required: true, message: this.$t('crm_lease_item_step_base.qxzfafl') }],
        productCodeArr: [{ required: true, message: this.$t('crm_lease_item_step_base.qxzcpxh') }],
        goodsDesc: [{ max: 200, message: this.$t('Common.com_rules_length_max', [200]) }],
      };
    },
  },
  mounted: function () {
    this.type = this.getJump('type') || (this.getJump('goodsId') ? 'edit' : 'add');
    this.form.categoryId = this.getJump('categoryId') || '';
    this.getGoodsInfo();
  },
  methods: {
    onChangeProduct: function (item) {
      const codes = item.map((t) => t.productCode);
      this.form.productSnArr = this.form.productSnArr.filter((t) => codes.some((f) => t.includes(f)));
    },
    // 变更组织类型
    onChangeGoodsSku: function () {
      if (!this.form.goodsSkuOwnerArr.includes('JV')) {
        this.form.organList = [];
        this.form.organListArr = [];
      }
    },
    // 变更适用公司
    onChangeOrganList: function (rows) {
      this.form.organList = rows.map((t) => ({ orgId: t.orgId, orgName: t.orgName }));
    },
    // 取消
    onCancel: function () {
      this.$emit('cancel');
    },
    // 获取方案信息
    getGoodsInfo: function () {
      const goodsId = this.goodsId || '';
      if (!goodsId) {
        return;
      }
      this.form.categoryId = this.categoryId;
      this.$getJSON(apis.GoodsInfo, { goodsId }).then((res) => {
        const result = res.data;
        this.$setFormatData(this.form, result);
        this.form.productCodeArr = this.form.productList.map((t) => t.productCode);
        const snArr = this.form.productList.filter((t) => !!t.productSns).map((f) => f.productSns.split(',').map((d) => `${f.productCode}/${d}`));
        this.form.productSnArr = snArr.reduce((a, b) => [...a, ...b], []);
        this.$emit('onProductCode', this.form.productCodeArr.join(','));
        this.form.goodsSkuOwnerArr = this.form.goodsSkuOwner.split(',');
        this.form.organListArr = this.form.organList.map((t) => t.orgId);
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.clearValidate();
          }
        });
      });
    },
    // 下一步
    onStep: function (isStep) {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.form.goodsSkuOwner = this.form.goodsSkuOwnerArr.join(',');
        this.form.productList = this.form.productCodeArr.map((t) => ({
          productCode: t,
          productSns: this.form.productSnArr
            .filter((f) => f.startsWith(t))
            .map((i) => i.replace(`${t}/`, ''))
            .join(','),
        }));
        if (this.dialog) {
          this.saveNewUpdate(isStep);
        } else if (this.type === 'add') {
          this.$emit('onProductCode', this.form.productCodeArr.join(','));
          this.saveInsert(isStep);
        } else {
          // this.type === 'edit'
          this.$emit('onProductCode', this.form.productCodeArr.join(','));
          this.saveUpdate(isStep);
        }
      });
    },
    saveInsert: function (isStep) {
      this.$postJSON(apis.GoodsAdd, this.form).then((res) => {
        if (isStep) {
          this.$emit('step', {
            goodsId: res.data,
          });
        } else {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
        }
      });
    },
    saveUpdate: function (isStep) {
      this.$postJSON(apis.GoodsUpadte, this.form).then(() => {
        if (isStep) {
          this.$emit('step');
        } else {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
        }
      });
    },
    // 新建并复制(用于合同修改租赁方案)
    saveNewUpdate: function (isStep) {
      this.form.customerId = this.customerId;
      this.$postJSON(apis.rmsGoodsCopyGoods, this.form).then((res) => {
        if (isStep) {
          this.$emit('step', {
            goodsId: res.data,
          });
        } else {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
        }
      });
    },
  },
};
</script>

<style lang="scss"></style>
